// Emphasis in script text: `_word_` or `*word*` (as in Fountain/Markdown),
// shown in italics. Stored with the markers; Rails strips them for the AI
// voice (Line#spoken_text uses the same rule).

export type Span = { text: string; emphasis: boolean }

// A marker pair hugging non-space text, not inside a word (so snake_case
// and 2*3*4 stay literal).
const EMPHASIS = /(?<![\p{L}\p{N}])([*_])(?=\S)(.+?)(?<=\S)\1(?![\p{L}\p{N}])/gu

export function emphasisSpans(text: string): Span[] {
  const spans: Span[] = []
  let last = 0
  for (const match of text.matchAll(EMPHASIS)) {
    const index = match.index ?? 0
    if (index > last) spans.push({ text: text.slice(last, index), emphasis: false })
    spans.push({ text: match[2] ?? '', emphasis: true })
    last = index + match[0].length
  }
  if (last < text.length) spans.push({ text: text.slice(last), emphasis: false })
  return spans
}

export function stripEmphasis(text: string): string {
  return text.replace(EMPHASIS, '$2')
}
